<header class="header">
  <div class="header-left">
    <img
      src="assets\logos\rocketclose-clearsign-logo.svg"
      alt="{{ 'header.LOGOALTTEXT' | translate }}"
      class="logo"
    />
  </div>

  <div class="header-right">
    <!-- Tablet & Desktop Items -->
    <div class="tablet-desktop-items">
      <app-language-selector></app-language-selector>
      <div>
        <button
          novaButton
          appTrackedButton
          data-testid="header-help-button"
          [trackId]="'header:help'"
          [trackType]="'expand'"
          variant="tertiary"
          [matMenuTriggerFor]="helpMenu.helpMenu()"
          aria-haspopup="true"
          [attr.aria-label]="'header.MENU.HELP' | translate"
          [title]="'header.MENU.HELP' | translate"
        >
          {{ "header.MENU.HELP" | translate }}
          <nova-icon class="nova-button__icon-right" name="phone_in_talk" [title]="'header.MENU.HELP' | translate" />
        </button>
        <app-help-menu #helpMenu></app-help-menu>
      </div>
    </div>

    <!-- User Menu Trigger -->
    @if (isAuthenticated()) {
      <button
        novaButton
        appTrackedButton
        data-testid="header-user-menu-button"
        [trackId]="'header:user-menu'"
        [trackType]="'expand'"
        variant="tertiary"
        [matMenuTriggerFor]="userMenu.userMenu()"
        aria-haspopup="true"
        [aria-label]="participantName()"
        [title]="'header.USER_MENU_TITLE' | translate"
      >
        <nova-icon name="account_circle" class="mobile-tablet-icon" [title]="'header.USER_MENU_TITLE' | translate"></nova-icon>
        <span class="desktop-text">{{ participantName() }}</span>
        <div class="participant-avatar">
          {{ participantInitial }}
        </div>
      </button>

      <app-user-menu
        #userMenu
        [participantName]="participantName()"
        [showExitSigning]="screenSize.isDesktop() === false && showExitSigning()"
        [showHelpOption]="screenSize.isTabletOrDesktop() === false"
        [showLanguageOption]="screenSize.isTabletOrDesktop() === false"
        [showParticipantName]="screenSize.isDesktop() === false"
        [isAuthenticated]="isAuthenticated()"
        (exitSigningClicked)="exitSigning()"
      ></app-user-menu>
    }

    <!-- Desktop Only Items -->
    <div class="desktop-only">
      @if (showExitSigning()) {
        <button
          novaButton
          appTrackedButton
          data-testid="header-exit-signing-button"
          [trackId]="'header:exit-signing'"
          [trackType]="'sign_out'"
          variant="secondary"
          [attr.aria-label]="'header.EXIT_SIGNING' | translate"
          [title]="'header.EXIT_SIGNING' | translate"
          (click)="exitSigning()"
        >
          {{ "header.EXIT_SIGNING" | translate }}
        </button>
      }
    </div>
  </div>
</header>

<app-exit-signing-modal #exitModal></app-exit-signing-modal>
